import { Typography, makeStyles, useTheme } from '@material-ui/core'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import DeleteIcon from '@material-ui/icons/Delete'
import { FieldArray, useField } from 'formik'
import React from 'react'

import {
  Button,
  Form,
  FormikImageFileField,
  FormikTextField,
} from 'src/modules/ui'

const useStyles = makeStyles(theme => ({
  images: {
    position: 'relative',
  },
  addPhoto: {
    marginTop: theme.spacing(1),
  },
  deletePhoto: {
    cursor: 'pointer',
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
  },
  logo: {
    position: 'absolute',
    left: theme.spacing(3),
    top: theme.spacing(3),
  },
  photo: {
    marginRight: theme.spacing(1),
  },
  photos: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  photoContainer: {
    position: 'relative',
  },
}))

const ProfileInfo = () => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <Form>
      <Form.InputGroup>
        <div className={classes.images}>
          <FormikImageFileField
            label="Cover"
            height={150 + theme.spacing(6)}
            margin="normal"
            name="coverImage"
            width="100%"
          />
          <FormikImageFileField
            className={classes.logo}
            height={150}
            label="Logo"
            margin="normal"
            name="logo"
            width={150}
          />
        </div>
        <FormikTextField
          fullWidth
          label="Description"
          margin="normal"
          multiline
          name="description"
        />
        <FormikTextField
          fullWidth
          label="Video URL"
          margin="normal"
          name="videoUrl"
          helperText="Must be link to Youtube or Vimeo video"
        />
      </Form.InputGroup>
      <Form.InputGroup title="Photos">
        <PhotosField name="photos" />
      </Form.InputGroup>
    </Form>
  )
}

const PhotosField = ({ name }) => {
  const classes = useStyles()
  const [field] = useField({ name })
  const { value } = field

  return (
    <FieldArray
      name="photos"
      render={({ push, remove }) => (
        <div>
          {value.length === 0 ? (
            <Typography>No photos</Typography>
          ) : (
            <div className={classes.photos}>
              {value.map(({ id, photo }, idx) => (
                <div className={classes.photoContainer} key={idx}>
                  <FormikImageFileField
                    className={classes.photo}
                    height={150}
                    margin="normal"
                    name={`${name}.${idx}.photo`}
                    width={150}
                  />
                  {!photo && (
                    <DeleteIcon
                      className={classes.deletePhoto}
                      onClick={() => remove(idx)}
                    />
                  )}
                </div>
              ))}
            </div>
          )}
          <Button
            className={classes.addPhoto}
            color="primary"
            onClick={() => push({ photo: '' })}
            startIcon={<AddCircleIcon />}
            variant="outlined"
          >
            Add Photo
          </Button>
        </div>
      )}
    />
  )
}

export default ProfileInfo
